var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"vmp-media-setting-menu"},_vm._l((_vm.filterMenuList),function(item){return _c('li',{key:item.id,staticClass:"vmp-media-setting-menu__item",class:{ 'vmp-media-setting-menu__item--active': _vm.selectedItem === item.id },on:{"click":function($event){return _vm.onClickItem(item)}}},[_vm._v(" "+_vm._s(_vm.$t(item.text))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }